import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaShare, FaEdit, FaEye } from 'react-icons/fa';

const ProductCard = ({ product }) => {
  const { product_id, name, weight, purity, making_charge, cover_image, quantity, category} = product;
  const [showShareDialog, setShowShareDialog] = useState(false);

  const handleShare = () => {
    setShowShareDialog(true);
  };

  const handleCopyLink = () => {
    const productUrl = `${window.location.origin}/wholesaler/inventory/${product_id}`;
    navigator.clipboard.writeText(productUrl);
    setShowShareDialog(false);
  };

  const handleShareToRetailers = () => {
    // Implement sharing to retailers functionality
    const productUrl = `${window.location.origin}/retailer/dashboard/${product_id}`;
    navigator.clipboard.writeText(productUrl);
    setShowShareDialog(false);
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      {/* Product Image */}
      <div className="relative h-48 w-full">
        <img
          src={cover_image}
          alt={name}
          className="w-full h-full object-cover"
        />
        {quantity <= 5 && (
          <div className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
            Low Stock
          </div>
        )}
      </div>

      {/* Product Details */}
      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">{name}</h3>
        <div className="grid grid-cols-2 gap-2 mb-4">
          <div>
            <p className="text-sm text-gray-500">Weight</p>
            <p className="font-medium">{weight} g</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Quantity</p>
            <p className="font-medium">{quantity}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Purity</p>
            {((!purity)?(
               <p className="font-medium"> - </p>
            ):(
              <p className="font-medium">{purity}</p>
            ))}
          </div>
          <div>
            <p className="text-sm text-gray-500">Making Charge</p>
            {((!making_charge)?(
              <p className="font-medium"> - </p>
            ):(
              <p className="font-medium">{making_charge}%</p>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-4 space-y-2">
        <Link
              to={`/wholesaler/inventory/${product_id}`}
              className="flex items-center justify-center w-full bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-600 transition-colors duration-300"
        >
          <FaEye className="mr-2" /> More Details
        </Link>
          
          <div className="flex space-x-2">
            <Link 
              to={`/wholesaler/inventory/${product_id}?mode=edit`}
              className="flex items-center justify-center w-full bg-red-500 text-white text-center px-4 py-2 rounded-md hover:bg-red-600 transition-colors duration-300"
            >
              <FaEdit className="mr-2" /> Edit
            </Link>
            <button
              onClick={handleShare}
              className="flex items-center justify-center w-full bg-blue-500 text-white text-center px-4 py-2 rounded-md hover:bg-blue-600 transition-colors duration-300"
            >
              <FaShare className="mr-2" /> Share
            </button>
          </div>
        </div>
      </div>

      {/* Share Dialog */}
      {showShareDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Share Product</h3>
            <div className="space-y-4">
              <button
                onClick={handleCopyLink}
                className="w-full bg-gray-100 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-200 transition-colors duration-300 flex items-center justify-center space-x-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                </svg>
                <span>Copy Link</span>
              </button>
              <button
                onClick={handleShareToRetailers}
                className="w-full bg-gray-100 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-200 transition-colors duration-300 flex items-center justify-center space-x-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span>Share to Retailers</span>
              </button>
            </div>
            <button
              onClick={() => setShowShareDialog(false)}
              className="mt-4 w-full bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors duration-300"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCard; 